module.exports = __webpack_public_path__ + "static/media/comment-alt-slash.e23e3e7f.svg";